<section class="container" *ngIf="imagesIdentifiers">
    <header class="header">
        <h2 class="title" [mdkChangeTextWithColorAndImage]="title"></h2>
    </header>

    <section class="note-container" *ngIf="note">
        <figure class="icon-container">
            <img class="card-element" [ngSrc]="'icons/palette.svg' | staticServe" width="16" height="16" alt="">
        </figure>
        <p class="description">{{note}}</p>
    </section>

    <section class="cards-theme-container">
        <figure class="card-container" *ngFor="let identifier of imagesIdentifiers"
            (click)="onSelectedTheme(identifier)">
            <img class="card-element" [ngSrc]="'MoCardFront-'+identifier+'.svg' | staticServe" width="242" height="154"
                alt="">
            <div class="label-card">
                <p class="label-text">{{identifier | formatMoCardText}}</p>
                <span class="label-amount">$0</span>
                <i class="icon pi pi-chevron-right"></i>
            </div>
        </figure>
    </section>
</section>